// import { filter } from "lodash";
import { useState, forwardRef, useEffect } from "react";
import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Portal } from "@mui/base";
import {
  Card,
  Table,
  Stack,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  Link,
} from "@mui/material";
// components
import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import { LocationListHead } from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
import Slide from "@mui/material/Slide";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import menu from "@iconify/icons-ic/baseline-menu";
import { CallApi } from "../statics.js";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian_calendar from "react-date-object/calendars/persian";
import persian_language from "react-date-object/locales/persian_fa";
import persian_language_en from "react-date-object/locales/persian_en";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/colors/green.css";
// import InputIcon from "react-multi-date-picker/components/input_icon";

const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "fullName", label: "Full Name", alignRight: false },
  { id: "mobile", label: "Mobile", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "referrerName", label: "Referrer Name", alignRight: false },
  { id: "createdAt", label: "Registration Date", alignRight: false },
  //   { id: "detail", label: "Details", alignRight: false },
];

export default function Members() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [submittedSearchValue, setSubmittedSearchValue] = useState("");

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [filterName, setFilterName] = useState("");

  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);
  const [totalMinDate, setTotalMinDate] = useState(null);
  const [totalMaxDate, setTotalMaxDate] = useState(null);

  const [submittedFilterDateValue, setSubmittedFilterDateValue] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    readAllCustomers();
  }, []);

  const readAllCustomers = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("readAllCustomers", "post", data).then((result) => {
      try {
        setDataLoading(false);
        if (result.status === 200) {
          console.log(result);
          setTableData(result.customers);
          setTotalItems(result.paginateInfo.totalItems);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) readAllCustomers();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const formatter = (value) => {
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  //   function CustomInput({ onFocus, value, onChange, placeholder, label }) {
  //     return (
  //       <TextField
  //         sx={{ width: "120px" }}
  //         size="small"
  //         label={label}
  //         onFocus={onFocus}
  //         value={value}
  //         onChange={onChange}
  //         placeholder={placeholder}
  //         InputProps={{
  //           className: "custom-input",
  //         }}
  //       />
  //     );
  //   }

  //   const onConfirmFilter = () => {
  //     let date = "";
  //     let date1 = "";
  //     console.log(new DateObject(startDateValue));
  //     if (startDateValue) {
  //       date = new DateObject(startDateValue)
  //         .convert(persian_calendar, persian_language_en)
  //         .format("YYYY-MM-DD");
  //     }
  //     if (endDateValue) {
  //       date1 = new DateObject(endDateValue)
  //         .convert(persian_calendar, persian_language_en)
  //         .format("YYYY-MM-DD");
  //     }
  //     setSubmittedFilterDateValue(date + "&&" + date1);
  //   };

  //   const onConfirmSearch = () => {
  //     setSubmittedSearchValue(searchValue);
  //   };

  //   useEffect(() => {
  //     if (submittedSearchValue || submittedFilterDateValue) {
  //       let dates = submittedFilterDateValue
  //         ? submittedFilterDateValue.split("&&")
  //         : ["", ""];
  //       let data = {
  //         username: getCookie("username"),
  //         token: getCookie("token"),
  //         page: page,
  //         count: rowsPerPage,
  //         searchKey: submittedSearchValue,
  //         fromDate: dates[0],
  //         toDate: dates[1],
  //       };
  //       readAllCustomers(data);
  //     }
  //   }, [submittedSearchValue, submittedFilterDateValue]);

  return (
    <Page title="Members | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Members
            </Typography>
          </Stack>

          <Card>
            {/* <div className="ordersFilterContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  // margin: "10px",
                }}
              >
                <TextField
                  // fullWidth
                  sx={{ width: "230px" }}
                  size="small"
                  autoFocus
                  type="text"
                  label="Search"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="order id, customer or mobile"
                  // disabled={buttonDisabled}
                />
                <Button
                  onClick={onConfirmSearch}
                  variant="contained"
                  // disabled={buttonDisabled}
                  startIcon={<Icon icon={searchFill} />}
                >
                  Search
                </Button>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  // margin: "10px",
                  fontFamily: "SFUIDisplay",
                }}
              >
                <DatePicker
                  render={<CustomInput placeholder="start date" label="from" />}
                  calendar={persian_calendar}
                  locale={persian_language}
                  minDate={totalMinDate}
                  // maxDate={new Date()}
                  maxDate={totalMaxDate}
                  weekDays={weekDays}
                  shadow={false}
                  value={startDateValue}
                  highlightToday={false}
                  onChange={(e) => {
                    console.log(e);
                    setStartDateValue(e);
                  }}
                  className="rmdp-mobile"
                  mobileButtons={[
                    {
                      label: "پاک کردن",
                      type: "button",
                      className: "rmdp-button rmdp-action-button",
                      onClick: () => setStartDateValue({}),
                    },
                  ]}
                />

                <DatePicker
                  render={<CustomInput placeholder="end date" label="to" />}
                  calendar={persian_calendar}
                  locale={persian_language}
                  minDate={
                    startDateValue ? new DateObject(startDateValue) : null
                  }
                  maxDate={totalMaxDate}
                  // maxDate={new Date()}
                  weekDays={weekDays}
                  shadow={false}
                  value={endDateValue}
                  onChange={(e) => {
                    setEndDateValue(e);
                  }}
                  className="rmdp-mobile"
                  mobileButtons={[
                    {
                      label: "پاک کردن",
                      type: "button",
                      className: "rmdp-button rmdp-action-button",
                      onClick: () => setEndDateValue({}),
                    },
                  ]}
                />

                <Button
                  onClick={onConfirmFilter}
                  variant="contained"
                  // disabled={buttonDisabled}
                  // startIcon={<Icon icon={searchFill} />}
                >
                  Filter
                </Button>
              </div>
            </div> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        return (
                          <TableRow hover key={row.id} tabIndex={-1}>
                            <TableCell>
                              {row.fullName ? row.fullName : "-"}
                            </TableCell>
                            <TableCell>{row.mobile}</TableCell>
                            <TableCell>{row.email ? row.email : "-"}</TableCell>
                            <TableCell>
                              {row.referrerName ? row.referrerName : "-"}
                            </TableCell>
                            <TableCell>
                              {row.createdAt.replace(" ", " - ")}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
